import isConnected from "./isConnected";
import { ds } from "../models/dataService";
import { _ } from "js/vendor";
import { app } from "js/namespaces";
import { AssetType } from "common/constants";
import log from "js/core/logger";
import { getImageType, isValidMediaType } from "js/core/utilities/imageUtilities";
import { ShowOfflineDialog, ShowUnsupportedFileTypesDialog, ShowWarningDialog } from "js/react/components/Dialogs/BaseDialog";

let isPastingImage = false;

export async function handlePasteImage(event) {
    if (!isConnected.connected) {
        ShowOfflineDialog();
        return;
    }

    if (isPastingImage) return;

    if (event.originalEvent.clipboardData?.files.length > 0) {
        let file = event.originalEvent.clipboardData.files[0];

        if (!isValidMediaType(file).isValidMedia) {
            return ShowUnsupportedFileTypesDialog();
        }

        let fileType = getImageType(file);

        try {
            let asset = await ds.assets.getOrCreateImage({
                file,
                fileType,
                assetType: AssetType.IMAGE,
                metadata: {
                    source: "paste"
                }
            });
            return asset;
        } catch (err) {
            isPastingImage = false;
            ShowWarningDialog({
                title: "Sorry!",
                message: "We were unable to upload this image. Please try again.",
            });
            log.error(err);
        }
    }
}
